<template>
    <div class="text-center">
        <div class="w-full font-medium text-center"><span class="italic font-thin">Need Help?</span> 1-800-583-9950</div>
        <div class="w-full font-thin text-center"> Copyright © {{year}} MyOutDesk LLC</div>
    </div>
</template>

<script>
    export default {
        name: 'Footer',
        data() {
            return {
                year: (new Date()).getYear() + 1900
            }
        }
    }
</script>

<style scoped>

</style>
